import React, { FC } from 'react';

import { FontAwesomeIcon } from '@appcharge/shared-ui';

import { cn } from '../lib/utils';
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
  UILabel
} from '../ui';

export interface DatePickerLabelProps {
  label?: string;
  infoTooltipContent?: string;
  isRequired?: boolean;
  disabled?: boolean;
}

export const DatePickerLabel: FC<DatePickerLabelProps> = ({
  label,
  infoTooltipContent,
  isRequired,
  disabled
}) => {
  return (
    <div
      className={cn(
        'flex text-p-s',
        disabled ? 'text-base-mutedForeground' : 'text-base-foreground'
      )}
    >
      <UILabel htmlFor={'uiInput'} className={cn('flex text-p-s')}>
        {isRequired && (
          <div className="mr-2 mt-1">
            <FontAwesomeIcon
              icon="fa-regular fa-asterisk"
              className="h-2 w-2 text-[8px]"
            />
          </div>
        )}
        {label}
      </UILabel>
      {infoTooltipContent && (
        <TooltipProvider>
          <Tooltip>
            <TooltipTrigger asChild>
              <div className={cn('cursor-pointer text-base-input ml-2')}>
                <FontAwesomeIcon icon="fa-regular fa-circle-question" />
              </div>
            </TooltipTrigger>
            <TooltipContent
              side="right"
              align="center"
              className="rounded-md border border-base-popover bg-base-popover shadow-md py-[6px] px-[12px]"
            >
              <span className="text-p-s text-base-mutedForeground">
                {infoTooltipContent}
              </span>
            </TooltipContent>
          </Tooltip>
        </TooltipProvider>
      )}
    </div>
  );
};
